import React, { useState, useEffect, MouseEvent, ChangeEvent } from "react";
import VendorCard from "./vendorCard";
import { getData, deleteData } from "../../actions";
import { Grid, Button, Grow, TextField, Typography } from "@material-ui/core";
import ArrowBackRoundedIcon from "@material-ui/icons/ArrowBackRounded";
import AdminModal from "../../modal/adminModal";
import Popover from "../../popover/popover";
// import AddMany from './addMany'
// import updateVendor from './updateVendor'
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import InboxIcon from "@material-ui/icons/Inbox";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import Snackbar from "../../snackbar/snackbar";
import Filter from "../../filter/filter";
import CircularProgress from "@material-ui/core/CircularProgress";
import Pagination from "@material-ui/lab/Pagination";
import { Paginated } from "../../../allrequests/paginate";
import { MenuItem, InputLabel, FormControl, Select } from "@material-ui/core";
import AddModal from "./AddModal";
import UpdateModal from "./UpdateModal";

const rowsPerPageDrodown = [6, 10, 50, 100];
const rowsPerPage = 6;

export default function VendorContainer(props) {
  const [defaultPage, setDefaultPage] = useState(1);
  const [perPage, setPerPage] = useState(rowsPerPage);
  const [vendorList, setVendorList] = useState([]); //displayed vendors
  const [vendors, setVendors] = useState([]); //actual vendor list @_@
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [popover, setPopover] = useState([]);
  const [successVendor, setSuccessVendor] = useState("");
  const [updateModal, setUpdateModal] = useState(false);
  const [updateModalId, setUpdateModalId] = useState("");
  const [wtaxOptions, setWtaxOptions] = useState([]);
  const [snackbar, setSnackBar] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [count, setCount] = useState("");
  const createData = (id, bpCode, bpName, vatType) => {
    return { id, bpCode, bpName, vatType };
  };
  const editIcon = <EditRoundedIcon color="primary" />;
  const updateVendor = (e, vendor) => {
    setUpdateModal(true);
    setPopover([null, ""]);
    setUpdateModalId(vendor);
  };

  useEffect(() => {
    componentDidMount();
  }, []);

  const componentDidMount = async () => {
    setIsLoading(true);
    let vendorsObj = [];
    try {
      const { data } = await getData("/vendors/spreadsheet/list");
      getData("/vendors/wTaxRates/spreadsheet/list").then((response) => {
          
        setWtaxOptions(response.data);
      });
      for (let obj of data) {
        vendorsObj.push(
          createData(obj._id, obj.bpCode, obj.bpName, obj.vatType)
        );
      }
      setVendors(data);
      setVendorList(Paginated(data, 1, perPage).data);
      setCount(Paginated(data, 1, perPage).total_pages);
    } catch (error) {
      alert(error);
        
    } finally {
      setIsLoading(false);
    }
  };
  const modals = (
    <>
      <AddModal
        existingData={vendors}
        saveData={vendorList}
        wtaxes={wtaxOptions}
        open={addModal}
        handleClose={(status) => {
          if (status !== "Cancel") {
            setSuccessVendor(status);
            componentDidMount();
          }
          setAddModal(false);
        }}
      />
      {updateModal ? (
        <UpdateModal
          open={updateModal}
          wow={updateModalId}
          wtaxes={wtaxOptions}
          handleClose={(status) => {
            if (status !== "Cancel") {
              setSuccessVendor(status);
              setSnackBar(true);
              componentDidMount();
            }
            setUpdateModal(false);
            setUpdateModalId("");
          }}
        />
      ) : null}
    </>
  );
  return (
    <>
      {modals}
      <Snackbar
        open={snackbar}
        handleClose={() => {
          setSnackBar(false);
        }}
      >
        Successfully updated the database for {successVendor}
      </Snackbar>
      <div style={{ padding: "1rem" }}>
        <Button type="button" color="primary" onClick={props.handleBack}>
          <ArrowBackRoundedIcon />
        </Button>
        <Button
          type="button"
          color="primary"
          size="small"
          onClick={() => {
            setAddModal(true);
          }}
        >
          Add Vendor
        </Button>
        <Grid container spacing={2}>
          <Grid item xs={10} sm={12}>
            <Filter
              listData={vendors}
              filterValue={filteredVendors}
              label="Search vendors ..."
              propertyName={"bpName"}
              onChange={(value) => setFilteredVendors(value)}
            />
          </Grid>
        </Grid>
      </div>
      {isLoading ? (
        <CircularProgress style={{ marginLeft: "46%" }} />
      ) : (
        <>
          {filteredVendors.length > 0
            ? filteredVendors.map((item) => (
                <Grow key={item.id} in={true}>
                  <Grid item xs={12} sm={12}>
                    <VendorCard
                      id={item.id}
                      bpName={item.bpName}
                      bpCode={item.bpCode}
                      vatType={item.vatType}
                      actionIcon={editIcon}
                      actions={(e) => {
                        updateVendor(e, item);
                        setUpdateModal(true);
                      }}
                    />
                  </Grid>
                </Grow>
              ))
            : vendorList.map((item) => (
                <Grow key={item.id} in={true}>
                  <Grid item xs={12} sm={12}>
                    <VendorCard
                      id={item.id}
                      bpName={item.bpName}
                      bpCode={item.bpCode}
                      vatType={item.vatType}
                      actionIcon={editIcon}
                      actions={(e) => {
                        updateVendor(e, item);
                        setUpdateModal(true);
                      }}
                    />
                  </Grid>
                </Grow>
              ))}
          {filteredVendors.length > 0 ? (
            ""
          ) : (
            <>
              <br />
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <div>
                    <InputLabel
                      style={{
                        float: "left",
                        marginRight: "1rem",
                        marginTop: ".5rem",
                      }}
                    >
                      Rows per page
                    </InputLabel>
                    <FormControl variant="outlined" size="small">
                      <Select
                        labelId="label"
                        id="select"
                        defaultValue={perPage}
                        onChange={(e) => {
                          const paginate = Paginated(
                            vendors,
                            1,
                            e.target.value
                          );
                          setVendorList(paginate.data);
                          setCount(paginate.total_pages);
                          setPerPage(e.target.value);
                        }}
                        color="inherit"
                      >
                        {rowsPerPageDrodown.map((value) => (
                          <MenuItem key={value} value={value}>
                            {value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </Grid>
                <Grid item xs={8}>
                  <Pagination
                    count={count}
                    defaultPage={defaultPage}
                    color="default"
                    style={{ float: "left" }}
                    onChange={(e, value) => {
                      const paginate = Paginated(vendors, value, perPage);
                      setVendorList(paginate.data);
                      setDefaultPage(value);
                    }}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </>
      )}
    </>
  );
}
